import React from "react";
import { cn } from "../../lib/utils";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/dialog";

const sizeClasses = {
  sm: "max-w-md",
  md: "max-w-xl",
  lg: "max-w-2xl",
  xl: "max-w-3xl",
  full: "max-w-[96vw]",
};

export function AppDialog({
  open,
  onOpenChange,
  trigger,
  title,
  children,
  footer,
  size = "md",
  scroll = true,
  className,
  titleClassName,
  contentClassName,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger ? <DialogTrigger asChild>{trigger}</DialogTrigger> : null}
      <DialogContent
        className={cn(
          "border-[#242E42] bg-[#151B26] text-[#F3F4F6]",
          sizeClasses[size] || sizeClasses.md,
          scroll && "max-h-[90vh] overflow-y-auto",
          className,
        )}
      >
        {title ? (
          <DialogHeader>
            <DialogTitle
              className={cn("font-['Outfit'] text-[#F3F4F6]", titleClassName)}
            >
              {title}
            </DialogTitle>
          </DialogHeader>
        ) : null}
        <div className={contentClassName}>{children}</div>
        {footer ? <div className="border-t border-[#242E42] pt-4">{footer}</div> : null}
      </DialogContent>
    </Dialog>
  );
}

export default AppDialog;
